import DetailsCard from "./DetailsCard";
import Tabcomponent from "./Tabcomponent";
function VerificationPage() {
  return (
    <>
      <div className="p-2 ">
        <DetailsCard />
      </div>
      <div>
        <Tabcomponent />
      </div>
    </>
  );
}

export default VerificationPage;
